
import React from 'react';

export const ContactSection = () => {
  const handleWhatsApp = () => {
    window.open('https://wa.me/554888397243?text=Ol%C3%A1!%20Gostaria%20de%20agendar%20um%20hor%C3%A1rio%20ou%20tirar%20d%C3%BAvidas%20sobre%20os%20servi%C3%A7os.', '_blank');
  };

  return (
    <section id="contato" className="py-12 md:py-20 bg-[#0D0D0D] relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-[#C8A45D]/5 to-transparent"></div>
      
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 md:mb-6 tracking-wide px-4">
            AGENDE SEU HORÁRIO
          </h2>
          <p className="text-base md:text-xl text-gray-300 max-w-2xl mx-auto px-4">
            Atendimento sob agendamento em Florianópolis – SC
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 md:gap-12 items-start">
          {/* Informações de Contato */}
          <div className="space-y-6 md:space-y-8">
            <div className="bg-[#1C1C1C] p-4 md:p-8 rounded-lg border border-[#C8A45D]/20">
              <h3 className="text-xl md:text-2xl font-bold text-white mb-4 md:mb-6">Entre em Contato</h3>
              
              <div className="space-y-4 md:space-y-6">
                <div className="flex items-start space-x-3 md:space-x-4">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-[#C8A45D] rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-line text-black text-lg md:text-xl"></i>
                  </div>
                  <div className="min-w-0 flex-1">
                    <p className="text-gray-400 text-xs md:text-sm">Telefone</p>
                    <p className="text-white font-medium text-sm md:text-base">(48) 8839-7243</p>
                  </div>
                </div>

                <div className="flex items-start space-x-3 md:space-x-4">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-[#C8A45D] rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-whatsapp-line text-black text-lg md:text-xl"></i>
                  </div>
                  <div className="min-w-0 flex-1">
                    <p className="text-gray-400 text-xs md:text-sm">WhatsApp</p>
                    <p className="text-white font-medium text-sm md:text-base">(48) 8839-7243</p>
                  </div>
                </div>

                <div className="flex items-start space-x-3 md:space-x-4">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-[#C8A45D] rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-black text-lg md:text-xl"></i>
                  </div>
                  <div className="min-w-0 flex-1">
                    <p className="text-gray-400 text-xs md:text-sm">Localização</p>
                    <p className="text-white font-medium text-sm md:text-base">Rua Antonio Matos Áreas, 60</p>
                    <p className="text-white font-medium text-sm md:text-base">Balneário - Estreito, Florianópolis - SC</p>
                    <p className="text-gray-400 text-xs md:text-sm">CEP: 88075-260</p>
                    <a 
                      href="https://share.google/E3RMJiWASnYyGYI1M" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-[#C8A45D] text-xs md:text-sm hover:text-[#B8944D] transition-colors duration-300 cursor-pointer inline-block mt-1"
                    >
                      Ver no Google Maps →
                    </a>
                  </div>
                </div>

                <div className="flex items-start space-x-3 md:space-x-4">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-[#C8A45D] rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-time-line text-black text-lg md:text-xl"></i>
                  </div>
                  <div className="min-w-0 flex-1">
                    <p className="text-gray-400 text-xs md:text-sm">Horário de Funcionamento</p>
                    <p className="text-white font-medium text-sm md:text-base">Segunda a Sexta: 8h às 18h</p>
                    <p className="text-gray-400 text-xs md:text-sm">Sábado e Domingo: Fechado</p>
                  </div>
                </div>

                <div className="flex items-start space-x-3 md:space-x-4">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-[#C8A45D] rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-star-fill text-black text-lg md:text-xl"></i>
                  </div>
                  <div className="min-w-0 flex-1">
                    <p className="text-gray-400 text-xs md:text-sm">Avaliação Google</p>
                    <div className="flex items-center space-x-2">
                      <div className="flex text-[#C8A45D]">
                        <i className="ri-star-fill text-sm"></i>
                        <i className="ri-star-fill text-sm"></i>
                        <i className="ri-star-fill text-sm"></i>
                        <i className="ri-star-fill text-sm"></i>
                        <i className="ri-star-fill text-sm"></i>
                      </div>
                      <span className="text-white font-medium text-sm">5.0</span>
                      <span className="text-gray-400 text-xs">(200+ avaliações)</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <button
              onClick={handleWhatsApp}
              className="w-full bg-[#C8A45D] text-black font-bold py-3 md:py-4 px-4 md:px-8 rounded-lg hover:bg-[#B8944D] transition-all duration-300 transform hover:scale-105 hover:shadow-lg hover:shadow-[#C8A45D]/25 whitespace-nowrap cursor-pointer text-sm md:text-base"
            >
              <i className="ri-whatsapp-line mr-2"></i>
              FALAR COM ESPECIALISTA
            </button>
          </div>

          {/* Mapa */}
          <div className="bg-[#1C1C1C] p-4 md:p-8 rounded-lg border border-[#C8A45D]/20">
            <h3 className="text-xl md:text-2xl font-bold text-white mb-4 md:mb-6">Nossa Localização</h3>
            <div className="aspect-video rounded-lg overflow-hidden">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d550.8623294244576!2d-48.58193921148815!3d-27.583578228923418!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9527378f2169506b%3A0x2628baae144ec164!2sAura%20Est%C3%A9tica%20Automotiva%20Florian%C3%B3polis!5e1!3m2!1spt-BR!2sbr!4v1761704719566!5m2!1spt-BR!2sbr"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                className="filter grayscale hover:grayscale-0 transition-all duration-300"
              ></iframe>
            </div>
            <div className="mt-4 text-center">
              <p className="text-gray-400 text-xs md:text-sm">
                Atendemos toda a região da Grande Florianópolis
              </p>
            </div>
          </div>
        </div>

        {/* Informações Adicionais */}
        <div className="mt-12 md:mt-16 text-center">
          <div className="bg-[#1C1C1C] p-6 md:p-8 rounded-lg border border-[#C8A45D]/20 max-w-4xl mx-auto">
            <h3 className="text-xl md:text-2xl font-bold text-white mb-4 md:mb-6">Por que escolher a Aura?</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center">
              <div>
                <div className="w-12 h-12 md:w-16 md:h-16 bg-[#C8A45D] rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-shield-check-line text-black text-xl md:text-2xl"></i>
                </div>
                <h4 className="text-white font-semibold mb-2 text-sm md:text-base">Garantia Aura</h4>
                <p className="text-gray-400 text-xs md:text-sm">Todos os serviços com garantia de qualidade</p>
              </div>
              <div>
                <div className="w-12 h-12 md:w-16 md:h-16 bg-[#C8A45D] rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-tools-line text-black text-xl md:text-2xl"></i>
                </div>
                <h4 className="text-white font-semibold mb-2 text-sm md:text-base">Equipamentos Premium</h4>
                <p className="text-gray-400 text-xs md:text-sm">Utilizamos produtos e equipamentos de última geração</p>
              </div>
              <div>
                <div className="w-12 h-12 md:w-16 md:h-16 bg-[#C8A45D] rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-award-line text-black text-xl md:text-2xl"></i>
                </div>
                <h4 className="text-white font-semibold mb-2 text-sm md:text-base">Excelência Comprovada</h4>
                <p className="text-gray-400 text-xs md:text-sm">5 estrelas no Google com 200+ avaliações</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
